/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder, whenCreateMode } from '@gh/common-shared';
import { mapErrorKeys } from '@gh/core-messages';
import { DialogInput, FormMode, NotificationService, WaitingService } from '@gh/core-ui';
import { catchError$, switchMap$ } from '@gh/rx/operators';
import { GoogleAuthService } from '@gh/core-external';
import {
  Printer,
  PrinterDetailsDialogConfig,
  SystemVarsPrinterListTabBusinessService,
} from '../../../resources';
import { of$ } from '@gh/rx';

@Component({
  standalone: false,
  selector: 'gh-system-vars-printer-details-dialog',
  templateUrl: 'system-vars-printer-details-dialog.component.html',
  styleUrls: ['system-vars-printer-details-dialog.component.scss'],
})
export class SystemVarsPrinterDetailsDialogComponent implements DialogInput<PrinterDetailsDialogConfig>, OnInit {
  input: PrinterDetailsDialogConfig;
  form: FormState<Printer>;

  constructor(private business: SystemVarsPrinterListTabBusinessService,
              private googleAuth: GoogleAuthService,
              private waitings: WaitingService,
              private notifications: NotificationService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>) {

  }

  ngOnInit(): void {
    const printer = this.input.printer;

    this.form = this.formStateBuilder.buildPlain({
      value: printer,
      mode: printer ? FormMode.EditMode : FormMode.CreateMode,
      children: {
        cloudPrinterId: { required: true, enabled: whenCreateMode() },
        cloudPrinterName: { required: true },
      },
    });
  }

  onSubmit(): void {
    if (this.form.group.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const save$ = this.form.createMode
      ? this.googleAuth.grantOfflineAccess().pipe(
        catchError$(mapErrorKeys<string>({
          'msg_google_auth:access_denied': 'msg_google_auth_print:access_denied',
        })),
        switchMap$((isConnected) => {
          if (isConnected) {
            return this.business.create({...this.form.submitValue, authCode: this.googleAuth.accessToken});
          }
          return of$('');
        })) : this.business.update(this.form.submitValue);

    save$.pipe(
      (this.waitings.operator()))
      .subscribe(
        (printer) => {
          this.notifications.success('msg_saved_successfully');
          this.dialogRef.close(printer);
        },
        this.notifications.processAll,
      );
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const printerDetailsDialogRoute = createDialogRoute({
  component: SystemVarsPrinterDetailsDialogComponent,
});
